<template>
  <div>
    <!-- <navbar-sas></navbar-sas> -->

    <div
      class="m-5 card p-4 tarjeta"
      id="normal"
      style="
        box-shadow: 10px 10px 25px 4px rgba(0, 0, 0, 0.1);
        min-height: 500px;
      "
    >
      <div class="mt-4">
        <div class="text-center">
          <h5 v-if="datos == true">Ingresa los datos y archivos solicitados</h5>
          <h5 v-if="iffactura == true">Datos de factura</h5>
          <h5 v-if="typeServicio == true">
            Carga los documentontos solicitados
          </h5>
        </div>
        <div class="tarjeta m-4 card p-2">
          <div>
            <div class="row mt-3 justify-content-center">
              <div class="col-3">
                <label class="form-label">Número de Reporte</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="numReporte"
                  maxlength="13"
                  placeholder="LAT0000000000"
                />
              </div>
              <div class="col-2">
                <label class="form-label">Subtotal</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="monto"
                  placeholder="000000.00"
                />
              </div>
              <div class="col-2">
                <label class="form-label">Siniestro</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="numSiniestro"
                  placeholder="000000000"
                  disabled
                />
              </div>
              <div class="col-2">
                <label class="form-label">Póliza</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="numPoliza"
                  placeholder="00000000"
                  disabled
                />
              </div>
              <div class="col-2">
                <label class="form-label">Inciso</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="inciso"
                  placeholder="0"
                  disabled
                />
              </div>
              <div class="col-3">
                <button
                  @click="validaNumeroReporte(true)"
                  type="button"
                  class="btn btn-blue mt-3 col-12"
                >
                  <i class="fas fa-check mr-2"></i>Validar datos
                </button>
              </div>
            </div>
          </div>
          <div v-if="iffactura == true">
            <div class="row justify-content-center mt-3">
              <div class="col-sm-5 col-md-5">
                <div class="card mt-3" style="border-radius: 17px">
                  <div class="row fila">
                    <div class="col-2 p-2 ml-4">
                      <img src="./Tools/img/xml.png" alt="" height="60px" />
                      <!-- <i style="color:rgb(0, 0, 0);" class="ml-2 mt-3 fas fa-file-excel fa-3x"></i> -->
                    </div>
                    <div class="col">
                      <h4 class="titulo ml-2 pt-2">XML</h4>
                      <div class="file-select file-select-dos" id="src-file1">
                        <input
                          type="file"
                          name="src-file1"
                          @change="onChangeFileXML($event)"
                          aria-label="Archivo"
                          accept=".xml"
                        />
                      </div>
                      <!-- :disabled="respuesta != '1'" -->
                    </div>
                    <div class="col-4 mt-1 mr-3" v-if="popover.ppvrXML">
                      <CButton
                        color="link"
                        shape="rounded-pill"
                        class="ml-5 mt-2"
                        v-c-tooltip="{
                          content: 'Archivo XML cargado correctamente.',
                          placement: 'right',
                        }"
                      >
                        <i
                          style="color: #96be25"
                          class="fal fa-check-circle fa-2x"
                        ></i>
                      </CButton>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4 col-md-5">
                <div class="card mt-3" style="border-radius: 17px">
                  <div class="row fila">
                    <div class="col-2 p-2 ml-4">
                      <img src="./Tools/img/pdf.png" alt="" height="60px" />
                      <!-- <i style="color:rgb(0, 0, 0);" class="ml-2 mt-3 fas fa-file-excel fa-3x"></i> -->
                    </div>
                    <div class="col">
                      <h4 class="titulo ml-2 pt-2">PDF</h4>
                      <div class="file-select file-select-dos" id="src-file1">
                        <input
                          type="file"
                          name="src-file1"
                          @change="onChangeFilePDF($event)"
                          aria-label="Archivo"
                          accept=".pdf"
                          cl
                        />
                      </div>
                      <!-- :disabled="respuesta != '1'" -->
                    </div>
                    <div class="col-4 mt-1 mr-3" v-if="popover.ppvrPDF">
                      <CButton
                        color="link"
                        shape="rounded-pill"
                        class="ml-5 mt-2"
                        v-c-tooltip="{
                          content: 'Archivo PDF cargado correctamente.',
                          placement: 'right',
                        }"
                      >
                        <i
                          style="color: #96be25"
                          class="fal fa-check-circle fa-2x"
                        ></i>
                      </CButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-1">
              <button @click="validaXML" type="button" class="btn btn-blue">
                <i style="color: #fffdfd" class="fas fa-check-circle mr-1"></i>
                Validar
              </button>
            </div>
          </div>
          <div v-if="typeServicio == true">
            <div class="row mt-5 justify-content-center">
              <div class="col-2 text-center mt-2">
                <label class="form-label ml-4">Tipo de servicio:</label>
              </div>
              <div class="col-4">
                <select v-model="servicio" class="form-control">
                  <option
                    v-for="(tipo, i) in tipoServicio"
                    :key="i"
                    :value="tipo.IdTipoServicio"
                  >
                    {{ tipo.Descripcion }}
                  </option>
                </select>
              </div>
              <div class="col-2">
                <button
                  @click="archivosTipoServicio"
                  type="button"
                  class="btn btn-blue"
                >
                  <!-- <button @click="archivosTipoServicio" type="button" class="btn btn-primary"> -->
                  <i style="color: #fffdfd" class="fas fa-file mr-1"></i>
                  Generar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3 pr-5 pl-5 mt-5" v-if="datostabla == true">
          <div class="col-12 mt-3">
            <div class="">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr class="text-center">
                      <th scope="col">Requisito</th>
                      <th scope="col">Adjuntar</th>
                      <th scope="col">Visor</th>
                    </tr>
                  </thead>
                  <tbody v-for="(result, i) in archivo" :key="i">
                    <tr>
                      <td style="width: 290px">{{ result.Descripcion }}</td>
                      <td style="width: 290px" class="justify-content-center">
                        <div
                          class="card mt-3"
                          style="border-radius: 17px; min-height: 70px"
                        >
                          <div class="row fila">
                            <div class="col-2 pt-3 pl-4">
                              <i
                                style="color: rgb(0, 0, 0)"
                                class="far fa-file fa-3x"
                              ></i>
                            </div>
                            <div class="col p-3">
                              <h6 class="titulo">{{ result.Descripcion }}</h6>
                              <div class="file-select">
                                <input
                                  @change="onChangeFileDocs($event, result)"
                                  type="file"
                                  accept="image/*, .pdf, .xml"
                                />
                              </div>
                            </div>
                            <div class="col-3 mt-1">
                              <CButton
                                color="link"
                                shape="rounded-pill"
                                class="p-3 mr-3"
                                v-if="result.cargado == true"
                                v-c-tooltip="{
                                  content: 'Archivo cargado correctamente.',
                                  placement: 'right',
                                }"
                              >
                                <i
                                  style="color: #96be25"
                                  class="fal fa-check-circle fa-2x"
                                ></i>
                              </CButton>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        style="width: 290px"
                        class="justify-content-center text-center"
                      >
                        <button
                          @click="mostrarPDF(result.IdArc, result.tipoA)"
                          type="button"
                          class="btn btn-blue col-8 mt-3"
                        >
                          <i style="color: #fffdfd" class="mr-2 far fa-eye"></i>
                          Ver
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-1" v-if="datostabla == true">
          <button
            @click="crearImportacion"
            type="button"
            class="btn btn-blue col-3"
          >
            <i style="color: #fffdfd" class="mr-2 fas fa-paper-plane"></i>
            Enviar solicitud
          </button>
        </div>

        <div style="height: 100px" class="text-center mt-1"></div>
      </div>
    </div>

    <div class="foot">
      <p>&copy; 2024 Latino Seguros.</p>
    </div>
    <NumeroImportacion :numImportacion="NumImportacion" />
    <iframeModal :documento="pdf" :isImage="isImage" />
    <ErrorModal :errorMessage="errorMessage" />
    <SuccessModal :successrMessage="successMessage" />
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script>
import Loading from "./Tools/loading.vue";
import NumeroImportacion from "./Modals/numeroImportacionModal.vue";
import iframeModal from "./Modals/iframeModal.vue";
import ErrorModal from "./Modals/errorModal.vue";
import SuccessModal from "./Modals/successModal.vue";
import NavbarSas from "./navbarSas.vue";
export default {
  components: {
    Loading,
    NavbarSas,
    NumeroImportacion,
    iframeModal,
    SuccessModal,
    ErrorModal,
  },
  data() {
    return {
      datos: true,
      iffactura: false,
      typeServicio: false,
      datostabla: false,
      tipoServicio: [],
      navigation: [],
      listArchivos: [],
      listArchivosUpload: [],
      archivo: [],
      infoArchivos: [],
      factura: [],
      errorMessage: "",
      successMessage: "",
      numPoliza: "",
      pdf: "",
      numSiniestro: "",
      resSiniextros: "",
      monto: "",
      servicio: "",
      cvvProve: "",
      respuesta: "",
      archivoBase64: "",
      archivoBase64Lista: "",
      nombrePDF: "",
      ArchivoXml: "",
      ArchivoPDF: "",
      extenArchivoD: "",
      nomreArchivoXml: "",
      uuid: "",
      RfcEmisor: "",
      Folio: "",
      tipoArchivoXml: "",
      inciso: "",
      ArchivoD: "",
      nombreArchivoD: "",
      tipoArchivoD: "",
      NumImportacion: "",
      IdTipoArchivo: "",
      subtotalFactura: "",
      textModal: "",
      titleModal: "",
      iconModal: "",
      numReporte: "",
      isLoading: false,
      ifmodal: true,
      colorModal: true,
      subtotalFactura: "",
      btnDocumentacion: true,
      ifProve: true,
      isImage: true,
      profileId: localStorage.getItem("profileId"),
      popover: {
        ppvrXML: false,
        ppvrPDF: false,
      },
    };
  },
  methods: {
    async mostrarPDF(base64, tipo) {
      this.$modal.show("ver-documento");
      var bin = btoa(base64);
      switch (tipo) {
        case "application/pdf":
          this.pdf = "data:application/pdf;base64," + base64;
          this.isImage = false; // Es un PDF, no una imagen
          break;
        case "image/jpeg":
          this.pdf = "data:image/jpeg;base64," + base64;
          this.isImage = true; // Es una imagen
          break;
        case "image/png":
          this.pdf = "data:image/png;base64," + base64;
          this.isImage = true; // Es una imagen
          break;
        default:
          break;
      }
    },
    //ya no se ocupa
    async validaSiniestroExistente(inciso) {
      this.isLoading = true;
      const payload = {
        metodo: "PPVALIDASINIESTROEXISTENTEID",
        data: {
          Poliza: this.numPoliza,
          Inciso: inciso,
          // Inciso: this.inciso,
          Siniestro: this.numSiniestro,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];
          // this.respuesta = res.Existente
          if (res.Existente == "1") {
            this.typeServicio = false;
            this.iffactura = true;
            this.datos = false;
            this.successMessage = "Datos validados exitosamente.";
            this.$modal.show("success-modal");
          } else {
            // this.typeServicio = false
            // this.iffactura = false
            // this.datos = false
            this.errorMessage =
              "No se encontro el siniestro " + this.numSiniestro;
            this.$modal.show("error-modal");
          }
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    async validaNumeroReporte(condicion) {
      this.listArchivos = [];
      this.listArchivosUpload = [];
      this.servicio = "";
      this.archivo = [];
      if (this.numReporte == "" || this.monto == "") {
        this.errorMessage =
          "El Número de Reporte y el Subtotal son requeridos.";
        this.$modal.show("error-modal");
        return;
      }
      this.isLoading = true;
      const payload = {
        metodo: "NUMEROREPORTESAS",
        data: {
          numeroReporte: this.numReporte,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          if (res[0].total != 0) {
            this.numSiniestro = res[0].resultado[0].numeroSiniestro;
            this.numPoliza = res[0].resultado[0].datos_poliza.noPoliza;
            this.inciso = res[0].resultado.numeroSiniestro;
            this.validaSiniestros(condicion);
          } else if (res[0].total == 0) {
            this.errorMessage =
              "No se obtuvieron resultados para el número de reporte: " +
              this.numReporte;
            this.$modal.show("error-modal");
            this.typeServicio = false;
            this.iffactura = false;
            this.isLoading = false;
          }
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.errorMessage = error;
          this.$modal.show("error-modal");
          this.isLoading = false;
        }
      } catch (e) {}
      // this.isLoading = false;
    },
    async validaSiniestros(condicion) {
      this.isLoading = true;
      const payloadExcel = {
        metodo: "VALIDASINIESTROSEXISTENTES",
        data: {
          SiniestrosExistentes: [
            {
              Siniestro: this.numSiniestro,
              Monto: "",
            },
          ],
        },
      };
      try {
        const responseExcel = await this.$store.dispatch(
          "metodoPost",
          payloadExcel
        );
        if (responseExcel) {
          this.resSiniextros =
            this.$store.getters.getRespuestaREST[0].SiniestrosExistentes;
          if (this.resSiniextros[0].Existente != "1") {
            this.$modal.show("error-modal");
            this.errorMessage = `El siniestro ${this.numSiniestro} no existe.`;
            this.isLoading = false;
            return;
          }
          this.inciso = this.resSiniextros[0].Inciso;
          this.typeServicio = false;
          this.iffactura = true;
          this.datos = false;
          this.datostabla = false;
          if (condicion) {
            this.successMessage = "Datos validados exitosamente.";
            this.$modal.show("success-modal");
            setTimeout(() => {
              this.$modal.hide("success-modal");
            }, 1500);
          }
        }
      } catch (errorE) {
        console.log(errorE);
      }
      this.isLoading = false;
    },
    onChangeFileXML(event) {
      this.ArchivoXml = event.target.files[0];
      this.nomreArchivoXml = event.target.files[0].name;
      this.tipoArchivoXml = event.target.files[0].type;
      this.popover.ppvrXML = true;
    },
    onChangeFilePDF(event) {
      this.ArchivoPDF = event.target.files[0];
      this.nombrePDF = event.target.files[0].name;
      this.popover.ppvrPDF = true;
    },
    async onChangeFileDocs(event, file) {
      this.ArchivoD = event.target.files[0];
      this.nombreArchivoD = event.target.files[0].name;
      this.tipoArchivoD = event.target.files[0].type;
      this.extenArchivoD = "." + event.target.files[0].name.split(".").pop();
      this.listArchivos.push(this.ArchivoD);

      //Convierte a base 64el archivo para mostarlo en btn "Ver"
      this.archivoBase64Lista = await this.convertBase64(this.ArchivoD);

      //busca por id los archivos que se cargaron con el mismo id
      let idbusqueda = this.listArchivosUpload
        .map((id) => id.TipoDocumento)
        .indexOf(file.IdArchivo);

      if (idbusqueda != -1) {
        //Si encontro un id repetido lo borra
        this.listArchivosUpload.splice(idbusqueda, 1);
      }

      for (let i = 0; i < this.archivo.length; i++) {
        //en el campo IdArc pone el base64 del archivo cargado
        if (file.IdArchivo == this.archivo[i].IdArchivo) {
          this.archivo[i].IdArc = this.archivoBase64Lista;
          this.archivo[i].tipoA = this.tipoArchivoD;
        }
      }
      let Archivos = {};
      Archivos = {
        TipoDocumento: file.IdArchivo,
        NombreArchivo: this.nombreArchivoD,
      };
      this.listArchivosUpload.push(Archivos);
    },
    convertBase64(blob) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          resolve(reader.result.split(",")[1]);
        };
      });
    },
    async validaXML() {
      /*if (this.ArchivoXml == '' || this.ArchivoPDF == '') {
                this.$swal({
                    icon: "error",
                    title: "Ambos documentos son obligatorios",
                    showConfirmButton: true,
                    background: '#fff',
                    backdrop: `rgba(0,0,123,0.4)`,
                    customClass: {
                        popup: 'swal-custom-popup'
                    }
                })
                return;
            }*/
      this.listArchivos = [];
      this.listArchivosUpload = [];
      this.ifProve = true;
      this.archivoBase64 = await this.convertBase64(this.ArchivoXml);

      if (this.ArchivoXml == "" || this.ArchivoPDF == "") {
        this.errorMessage = "Ambos documentos son obligatorios.";
        this.$modal.show("error-modal");
        return;
      }
      if (this.tipoArchivoXml != "text/xml") {
        this.errorMessage = "Documento XML invalido.";
        this.$modal.show("error-modal");
        return;
      }

      this.isLoading = true;
      const payload = {
        metodo: "VALIDARDOCUMENTOSXML",
        data: {
          DocumentXmlBase64: this.archivoBase64,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.isLoading = false;
          const emisor = res.TransactionProperties.find(
            (prop) => prop.keyField === "RFC Emisor"
          );
          this.RfcEmisor = emisor.valueField;

          //validacion RFC Emisor sea igual al usuario
          if (this.RfcEmisor != localStorage.getItem("userId")) {
            this.errorMessage =
              "El RFC de la factura " +
              res.DatosAdicionales[2].valor +
              " es diferente al usuario logueado.";
            this.$modal.show("error-modal");
            return;
          }
          //validacion que la respuesta no venga vacia
          if (res.TransactionProperties == null) {
            this.errorMessage = "Documento XML invalido.";
            this.$modal.show("error-modal");
            return;
          }
          //validacion de errores que trae la respuesta
          if (res.ValidationResult.documentIsValid == false) {
            this.errorMessage = res.ValidationResult.failedRules[0].titleField;
            this.$modal.show("error-modal");
            return;
          }
          this.factura = res;
          this.Folio = res.DatosAdicionales[0].valor;
          this.uuid = res.DatosAdicionales[1].valor;
          let descuento = "";
          res.TransactionProperties.map((data) => {
            if (data.keyField == "Subtotal") {
              this.subtotalFactura = data.valueField;
            }
            if (data.keyField == "Descuento") {
              descuento = data.valueField;
            }
          });
          // this.monto = this.subtotalFactura - descuento //temporal hasta saber de donde tomar el monto
          if (this.RfcEmisor == "") {
            this.errorMessage = "La factura no cuenta con un RFC valido.";
            this.$modal.show("error-modal");
            return;
          }
          let operacion = this.subtotalFactura - descuento;
          let x = Number(this.monto).toFixed(2);

          if (operacion.toFixed(2) != x) {
            this.errorMessage = `El subtotal de la Factura: $${operacion.toFixed(
              2
            )}, no coincide con el Subtotal ingresado: $${x}`;
            this.$modal.show("error-modal");
          } else {
            this.searchProveedor();
            setTimeout(() => {
              if (this.ifProve == true) {
                this.successMessageMessage = "Validacion exitosa.";
                this.$modal.show("success-modal");
                this.iffactura = false;
                this.datos = false;
                this.typeServicio = true;
                if (res.DatosAdicionales.length > 0) {
                  this.getTipoServicio();
                  this.btnDocumentacion = false;
                }
                let archivoXML = {
                  TipoDocumento: "140",
                  NombreArchivo: this.nomreArchivoXml,
                };
                this.listArchivosUpload.push(archivoXML);
                let archivoPDF = {
                  TipoDocumento: "150",
                  NombreArchivo: this.nombrePDF,
                };
                this.listArchivosUpload.push(archivoPDF);

                this.listArchivos.push(this.ArchivoXml);
                if (this.ArchivoPDF != "") {
                  this.listArchivos.push(this.ArchivoPDF);
                }
              }
            }, 2000);
          }
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async validaFactura() {
      this.archivoBase64 = await this.convertBase64(this.ArchivoXml);
      const payload = {
        metodo: "VALIDARDOCUMENTOSXML",
        data: {
          DocumentXmlBase64: this.archivoBase64,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];
          // this.respuesta = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    listaArchivosPPimportar(file) {
      this.listArchivosUpload = [];
      let Archivos = {};

      for (let i = 0; i < this.listArchivos.length; i++) {
        Archivos = {
          TipoDocumento: file.IdArchivo,
          Cantidad: "1",
        };
        this.listArchivosUpload.push(Archivos);
      }
    },
    async searchProveedor() {
      this.isLoading = true;
      const payload = {
        metodo: "PPLISTARPROVEEDORES",
        data: {
          filtro: this.RfcEmisor,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];
          console.log(res);
          if (res.Prestadores[0].Proveedor == "") {
            this.$modal.hide("success-modal");
            this.errorMessage = `El RFC: ${this.RfcEmisor} es inválido o no existe.`;
            this.$modal.show("error-modal");
            this.iffactura = true;
            this.datos = false;
            this.typeServicio = false;
            this.ifProve = false;
            this.isLoading = false;
            return;
          }

          this.cvvProve = res.Prestadores[0].CveProveedor;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    async generaNumImportacion() {
      let total = "";
      let subtotal = "";
      let descuento = "";
      this.factura.TransactionProperties.map((data) => {
        if (data.keyField == "Total") {
          total = data.valueField;
        }
        if (data.keyField == "Descuento") {
          descuento = data.valueField;
        }
        if (data.keyField == "Subtotal") {
          subtotal = data.valueField;
        }
      });

      const payload = {
        metodo: "PPIMPORTAR",
        data: {
          Factura: this.Folio,
          Uuid: this.uuid,
          Subtotal: subtotal - descuento,
          RFC: this.RfcEmisor,
          TipoImportacion: "Individual",
          TipoGasto: "36",
          ClaveProveedor: this.cvvProve,
          IdTipoServicio: this.servicio,
          Total: total,
          Siniestros: [
            {
              Siniestro: this.numSiniestro,
              Monto: this.monto,
              Existente: this.resSiniextros[0].Existente,
              Estimado: this.resSiniextros[0].Estimado,
              IdCobertura: this.resSiniextros[0].IdCobertura,
              CveCobertura: this.resSiniextros[0].CveCobertura,
            },
          ],
          Archivos: this.listArchivosUpload,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];
          this.NumImportacion = res.NumImportacion;

          if (res.NumImportacion != "") {
            this.$modal.show("importacion");
            this.folioXRol();
          }
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.errorMessage = error.split("|")[1];
          this.$modal.show("error-modal");
          this.isLoading = false;
        }
      } catch (errorE) {
        console.log(errorE);
      }
      this.isLoading = false;
    },
    async folioXRol() {
      this.isLoading = true;
      this.tipoServicio = [];
      const payload = {
        metodo: "USUARIOFOLIOXROL",
        data: {
          IdAplicacion: 26, //La aplicacion en donde se va a asignar
          IdRol: "20167", // el rol del usuario en donde se asignara el folio
          Folio: this.NumImportacion, //folio o nuero de importacion.
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    async getTipoServicio() {
      this.isLoading = true;
      this.tipoServicio = [];
      const payload = {
        metodo: "PPLISTATIPOSERVICIOREPARACION",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];

          this.tipoServicio.push(...res);
          this.datostabla = true;
          if (this.servicio != "") {
            this.archivosTipoServicio();
          }
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    async archivosTipoServicio() {
      this.isLoading = true;
      this.archivo = [];
      const payload = {
        metodo: "PPLISTAARCHIVOSTIPOSERVICIO",
        data: {
          IdTipoServicio: this.servicio,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST[0];

          this.infoArchivos.push(...res.Documentos);
          this.archivo.push(...res.Documentos);
          for (let i = 0; i < res.length; i++) {
            this.IdTipoArchivo = this.archivo[i].IdArchivo;
          }
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    async cargarDocumentos() {
      try {
        for (let i = 0; i < this.listArchivos.length; i++) {
          let nombreArchivo = this.listArchivos[i].name.split(".");
          const base64 = await this.convertBase64(this.listArchivos[i]);
          
          // Primer payload: UPLOADFILE
          const payload = {
            metodo: "UPLOADFILE",
            data: {
              psBase64: base64,
              psNombreArchivo: nombreArchivo[0],
              psExtension: "." + this.listArchivos[i].name.split(".").pop(),
              psContentType: this.listArchivos[i].type,
              psIdOperacion: 5,
            },
          };
          console.log("Primer payload enviado (UPLOADFILE):", payload);

          const response = await this.$store.dispatch("metodoPost", payload);
          console.log("envio 1", response);

          if (response) {
            const res = this.$store.getters.getRespuestaREST;
          } else {
            // let error = this.$store.getters.getDataRaw.errorMessage;
            this.errorMessage =
              "Verifica el contenido del archivo, no se permiten extensiones .exe, .bat, .cmd etc..";
            this.$modal.show("error-modal");
            this.isLoading = false;
            return false; // Retorna false si ocurre un error
          }

          var descripcion = nombreArchivo[0];

          try{
            descripcion = i <= 1 ? nombreArchivo[0] : this.archivo[i-2].Descripcion;
          }
          catch(error){
            descripcion = nombreArchivo[0];
          }
          
          // Segundo payload: PPCargarImagenLatino
          const payload2 = {
            metodo: "PPCargarImagenLatino",
            data: {
              numeroReporte: this.numReporte, 
              Fotos: [
                {
                  descripcion: descripcion, //this.archivo[i].Descripcion, 
                  nombreImagen: `${nombreArchivo[0]}.${nombreArchivo[1]}`,
                  base64: base64, 
                },
              ],
            },
          };
          const response2 = await this.$store.dispatch("metodoPost", payload2);
          console.log("envio 2",response2);

          if (!response2) {
            this.errorMessage =
              "Error al cargar el archivo en el segundo endpoint.";
            this.$modal.show("error-modal");
            this.isLoading = false;
            return false; // Retorna false si ocurre un error en el segundo endpoint
          }
        }
        return true; // Retorna true si todos los documentos se cargan correctamente
      } catch (error) {
        console.log(error);
      } finally {
      }
    },
    cleanIndividual() {
      this.modals.info = false;
      window.location.reload();
    },
    async crearImportacion() {
      this.isLoading = true;
      let error = await this.cargarDocumentos();

      if (error === true) {
        this.generaNumImportacion();
      } else {
        this.validaNumeroReporte(false);
      }
      this.isLoading = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: white;
  border-radius: 30px !important;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}
.btn-blue {
  border-radius: 10px;
  background-image: linear-gradient(
    to right,
    #085da8,
    #003c71
  ); /* Color de fondo verde */
  border: #003c71;
  color: white;
}
.tarjeta {
  border-radius: 25px;
}
.btn-modal {
  background-color: #3085d6;
  color: #ffffff;
  font-size: medium;
}
.swal-modal .swal-text {
  text-align: center;
}
.custom-input-file {
  background-color: #ffffff;
  color: #858383;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  margin: 0 auto 0;
  min-height: 15px;
  overflow: hidden;
  /* padding: 10px; */
  position: relative;
  text-align: center;
  width: 140px;
}

.custom-input-file .input-file {
  /* border: 10000px solid transparent; */
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}

.borde {
  border-top-left-radius: 0.5em 1em;
  border-bottom-left-radius: 0.5em 1em;
}

.iframePdf {
  width: 100%;
  height: 500px;
}
.card-header {
  background-color: rgb(33, 46, 102);
}
.cardxs {
  margin: 0;
}
small {
  font-size: small;
}
.file-select-dos {
  width: 160px !important;
}
.file-select {
  position: relative !important;
  display: inline-block !important;
  cursor: pointer !important;
}

.file-select::before {
  background-color: #ffffff !important;
  color: rgba(4, 12, 34, 0.664) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  /* border-radius: 3px; */
  content: "Seleccionar" !important;
  position: absolute !important;
  left: 5% !important;
  top: 20% !important;
  cursor: pointer !important;
}

.file-select input[type="file"] {
  opacity: 0 !important;
  width: 200px !important;
  height: 32px !important;
  display: inline-block !important;
  cursor: pointer !important;
}

#src-file1::before {
  content: "Selecciona tu archivo" !important;
  cursor: pointer !important;
}
html {
  min-height: 100%;
  position: relative;
}
body {
  margin: 0;
  /* margin-bottom: 40px; */
}
.titulo {
  margin: 0;
  align-content: center;
}
.foot {
  /* position: sticky; */
  background-color: #003c71;
  height: 60px;
  margin-top: 10%;
}
.foot p {
  padding: 20px;
  color: #ffffff;
  text-align: center;
}
#yourBtn {
  font-family: calibri;
  width: 170px;
  /* text-align: center; */
  margin-left: 20px;
  background-color: rgb(255, 255, 255);
  cursor: pointer;
}
.navbar {
  background-color: white;
  height: 90px;
}
.imagen {
  height: 50px;
}
.cardTabla {
  box-shadow: 5px 5px 5px rgb(218, 216, 216);
  border-radius: 10px;
}
.icono {
  color: #000000;
}
.columnaIcono {
  background-color: #ece9e8;
}
.columnaIconoxs {
  background-color: #d4ddf7;
}
.fila {
  margin-left: 0.5px;
}
.coltxt {
  padding: 10px;
  line-height: 0;
}
</style>
